import { z } from "zod";
import { schemes } from "@zeal/common";

export const getInvoiceStatsRequestSchema = z.object({
  companyID: schemes.companyID(),
  search: z.string().optional().default(""),
  status: z.string().optional(),
  payment_status: z.string().optional(),
  invoiceDateFrom: z.string().optional(),
  invoiceDateTo: z.string().optional(),
  dueDateFrom: z.string().optional(),
  dueDateTo: z.string().optional(),
});

export type TGetInvoiceStatsRequest = z.infer<
  typeof getInvoiceStatsRequestSchema
>;

export const getInvoiceStatsResponseSchema = z.object({
  totalCount: z.number().optional(),
  byStatus: z.record(z.number()).optional(),
  open: z.object({
    count: z.number(),
    amountCents: z.number(),
  }),
  overdue: z.object({
    count: z.number(),
    amountCents: z.number(),
  }),
  paid: z.object({
    count: z.number(),
    amountCents: z.number(),
  }),
});

export type TGetInvoiceStatsResponse = z.infer<
  typeof getInvoiceStatsResponseSchema
>;
